/* eslint-disable @typescript-eslint/no-unused-expressions */
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { LoadingButton } from "@mui/lab";
import {
  Avatar,
  Box,
  Button,
  Chip,
  FormControl,
  Grid,
  InputLabel,
  ListItemText,
  MenuItem,
  Paper,
  Select,
  TextField,
  Typography,
} from "@mui/material";
import OutlinedInput from "@mui/material/OutlinedInput";
import { DatePicker } from "@mui/x-date-pickers";
import dayjs, { Dayjs } from "dayjs";
import { useFormik } from "formik";
import React, { ChangeEvent, useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router";
import { v4 as uuidv4 } from "uuid";
import { DefaultPage } from "../../../layouts/default-page";
import { Notify } from "../../../layouts/notify";
import { BoardMember } from "../../../models/BoardMember";
import { Movie } from "../../../models/Movie";
import { getBoardMembers } from "../../../services/ChannelService";
import { upload } from "../../../services/Upload";
import {
  useAddMoveMutation,
  useGetCategoriesQuery,
  useGetGenresQuery,
  useUpdateMovieMutation,
} from "../../../services/movies.query";
import BoardMemberValidationsForm from "./validation";
import { useAddBoardMemberMutation, useUpdateBoardMemberMutation, useUpdateOfficialMutation } from "../../../services/appointees.query";
import { kMaxLength } from "buffer";
import { Official } from "../../../models/Official";

export default function OfficialDetails() {
  const navigate = useNavigate();

  // const [addOfficial, { isLoading: addOfficialLoading }] = useAddBoardMemberMutation();
  const [updateOfficial, { isLoading: updateOfficialLoading }] = useUpdateOfficialMutation();

  const location = useLocation();
  const officialData = location.state?.official;

  const formik = useFormik({
    initialValues: {
      title: officialData ? officialData.title : "",
      description: officialData ? officialData.description : "",
      profile_file: officialData ? officialData.profile_url : null,
    },
    validationSchema: BoardMemberValidationsForm,
    onSubmit: async (values, { resetForm }) => {
      console.log("values", values);
      let formData: Official = {
        title: values.title,
        description: values.description,
        profile_url: "",
      };

      if (officialData) {
        formData.id = officialData.id;
      }

      if (profileUrl && typeof profileUrl !== "string") {
        const file = profileUrl;
        const fileExt = file?.name?.split(".").pop();
        const filePath = `${uuidv4()}-${Math.random()}.${fileExt}`;
        let data = await upload(file, "images/officials", filePath);
        formData.profile_url = data.url;
      } else if (typeof profileUrl === "string") {
        formData.profile_url = profileUrl;
      } else if (officialData?.profile_url) {
        formData.profile_url = officialData.profile_url;
      }


      try {
        if (!officialData) {
          // await addBoardMember(formData);
          Notify("success", "Movie created successfully");
        } else {
          await updateOfficial(formData);
          Notify("info", "Board Member updated successfully");
        }
        setOpen(false);
        resetForm();
        navigate("/app-contents/officials");
      } catch (error) {
        console.error("Error during form submission:", error);
        Notify("error", "Error occurred while saving movie, "+ error);
      }
    },
  });

  const [profileUrl, setProfileUrl] = useState<File | null>(
    officialData?.profile_url ?? null
  );
  //   const [coverImage, setCoverImage] = useState<File | null>(
  //     movieData?.cover_img ?? null
  //   );
  //   const [premiere_date, setPremiereDate] = useState<Dayjs | null | undefined>(
  //     null
  //   );
  const [open, setOpen] = useState<boolean>(false);
  const [isFocused, setIsFocused] = useState(false);
  const [genreIsFocused, setGenreIsFocused] = useState(false);
  const [isOpen, setIsOpen] = useState(false);
  const [isPremiereDateOpen, setPremiereIsOpen] = useState(false);
  const [isCommitteeSelected, setIsCommitteeSelected] = useState(false);
  const [users, setBoardMembers] = useState<BoardMember[]>([]);

  //   const { data: categories, isLoading: categoriesLoading } =
  //     useGetCategoriesQuery("");
  //   const { data: genres, isLoading: genresLoading } = useGetGenresQuery("");

  //   useEffect(() => {
  //     const fetchUserData = async () => {
  //       try {
  //         let data = await getBoardMembers();
  //         if (data) {
  //           setBoardMembers(data);
  //         }
  //       } catch (error) {
  //         console.error("Error fetching types:", error);
  //       }
  //     };

  //     fetchUserData();
  //   }, []);

  useEffect(() => {
    formik.setFieldValue("profile_file", officialData?.profile_url);
    // formik.setFieldValue("cover_file", movieData?.cover_img);
  }, [officialData]);

  const handleAvatarImageChange = (e: ChangeEvent<HTMLInputElement>) => {
    if (e.target.files && e.currentTarget.files) {
      setProfileUrl(e.target.files[0]);
      formik.setFieldValue("profile_file", e.currentTarget.files[0]);
      formik.setErrors({ profile_file: "" });
    }
  };


  return (
    <DefaultPage
      title={officialData ? "Edit Official" : "Add Official"}
    //   loading={categoriesLoading || genresLoading}
    >
      <Paper elevation={0}>
        <form autoComplete="off" onSubmit={formik.handleSubmit}>
          <Grid container spacing={6}>
            <Grid item xs={12} sm={4} md={4}>
              <Box
                sx={{
                  display: "flex",
                  flexDirection: "column",
                  justifyContent: "center",
                  alignItems: "center",
                  bgcolor: "#DEECFF",
                  width: "100%",
                  height: 300,
                  borderRadius: 5,
                }}
              >
                <Typography variant="subtitle1">Profile Image</Typography>

                <input
                  accept="image/*"
                  style={{ display: "none" }}
                  id="avatar_contained-file"
                  type="file"
                  multiple
                  name="avatar_file"
                  onChange={handleAvatarImageChange}
                  onBlur={formik.handleBlur}
                />
                <label htmlFor="avatar_contained-file">
                  <Button
                    sx={{
                      width: "100%",
                      height: 200,
                      ":focus": {
                        border: "none",
                        outline: "none",
                        bgcolor: "transparent",
                      },
                      ":hover": {
                        border: "none",
                        outline: "none",
                        bgcolor: "transparent",
                      },
                    }}
                    variant="text"
                    component="span"
                    startIcon={<img alt="upload icon" src="/upload.png" />}
                  >
                    {profileUrl && typeof profileUrl === "string" ? (
                      <img
                        src={profileUrl}
                        style={{ width: 100, height: 100 }}
                        alt="avatar"
                      />
                    ) : (
                      profileUrl && (
                        <img
                          src={URL.createObjectURL(profileUrl)}
                          style={{ width: 100, height: 100 }}
                          alt="avatar"
                        />
                      )
                    )}
                  </Button>
                </label>
                {profileUrl && typeof profileUrl !== "string" && (
                  <span>
                    {profileUrl.name.length > 15
                      ? `${profileUrl.name.slice(0, 15)}...`
                      : profileUrl.name}
                  </span>
                )}
                {formik.errors.profile_file && !officialData && (
                  <span style={{ color: "red", fontSize: "16px" }}>
                    {formik.errors.profile_file as any}
                  </span>
                )}
              </Box>
            </Grid>

            <Grid
              item
              xs={12}
              sm={8}
              md={8}
              sx={{ marginTop: 2 }}
              direction="column"
              container
            >
              <FormControl fullWidth>
                <Typography
                  sx={{
                    borderRadius: 5,
                  }}
                >
                  Full Name
                </Typography>
                <TextField
                  InputProps={{
                    disableUnderline: true,
                  }}
                  id="id_title"
                  name="title"
                  variant="outlined"
                  type="text"
                  placeholder="e.g Joanna Doe"
                  value={formik.values.title}
                  onChange={formik.handleChange}
                  error={
                    formik.touched.title && Boolean(formik.errors.title)
                  }
                  helperText={
                    formik.touched.title && (formik.errors.title as any)
                  }
                  onBlur={formik.handleBlur}
                />
              </FormControl>
              <FormControl fullWidth>
                <Typography
                  sx={{
                    borderRadius: 5,
                  }}
                >
                  Description
                </Typography>
                <TextField
                  multiline
                  InputProps={{
                    disableUnderline: true,
                  }}
                  rows={15}
                  variant="outlined"

                  id="id_description"
                  name="description"
                  value={formik.values.description}
                  onChange={formik.handleChange}
                  placeholder="Type your message here"

                />
              </FormControl>
            </Grid>
            <Grid item xs={12} sm={6} md={6} mx="auto" justifyContent="center">
              <LoadingButton
                type="submit"
                variant="contained"
                color="primary"
                className="hover:bg-green-700 text-white px-4 py-2 rounded-md"
                sx={{
                  width: "60%",
                  height: 50,
                  bgcolor: "#0054D3",
                  borderRadius: "55px",
                  textTransform: "none",
                }}
                loading={
                  formik.isSubmitting || updateOfficialLoading || updateOfficialLoading
                }
              >
                {officialData ? "Update Official" : "Add Official"}
              </LoadingButton>
            </Grid>
          </Grid>
        </form>
      </Paper>

    </DefaultPage>
  );
}
